<template>
    <div class="content">
        <div class="content__header bg-color-yellow4">
            <h1 class="content__header__heading content__diary__form__heading">Skriv en tanke</h1>
        </div>
        <div class="content__diary__form">
            <textarea v-model="note" class="content__diary__form__note">

            </textarea>
            <div class="content__diary__form__buttons">
                <button v-if="edit" v-on:click="remove" class="content__block__button content__diary__form__button">Slett</button>
                <button v-else v-on:click="cancel" class="content__block__button content__diary__form__button">Avbryt</button>
                <button v-on:click="save" class="content__block__button content__diary__form__button">Lagre</button>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapState, mapActions } from 'vuex';

    export default {
        name: 'Subpage',
        props: {
            entry: {
                type: Object
            },
        },
        data: function () {
            return {
                edit:false,
                note:'',
            }
        },
        computed: mapState([
            'color'
        ]),
        created() {
            this.getForm();
        },
        beforeRouteUpdate (/*to, from, next*/) {
            this.getForm();
        },
        methods: {
            ...mapActions([
                'setBack',
                'setColor',
                'addDiaryEntry',
                'removeDiaryEntry']),

            getForm() {
                try {
                    this.edit = this.entry && this.entry.date;
                    this.note = this.entry && this.entry.note ? this.entry.note : '';

                    let slugs = window.location.pathname.substr(1).split('/');
                    slugs.pop();
                    
                    this.setBack(slugs.join('/'));
                    this.setColor('yellow4');

                } catch (e) {
                    window.console.log(e);
                }
            },
            save() {
                if(!this.edit) {
                    if(this.note) {
                        this.addDiaryEntry({
                            note: this.note,
                            date: new Date()
                        });
                    }
                } else {
                    this.entry.note = this.note;
                }
                this.$router.back();
            },
            remove() {
                this.removeDiaryEntry(this.entry);
                this.$router.back();
            },
            cancel() {
                this.$router.back();
            },
        }
    };
</script>

<style lang="scss" scoped>
    .content {
        flex-grow: 1;
        flex-direction: column;

        display: flex;
        flex-direction: column;
        align-items: center;        

        &__header {
            width:100%;
            &__heading {
                padding:22px 0;

                color:#fff;
                text-align: center;
                font-size: 22px;
            }
        }

        &__audio {
            padding:50px 0 30px 0;
            text-align: center;

            &__heading {
                margin-top:30px;
                color:#fff;
            }
        }
    }

    .content__diary__form {
        display:flex;
        flex-direction: column;
        align-items: center;

        width: 100%;
        max-width: 960px;
        margin:0 auto;
        padding:50px 25px;

        &__heading {
            color:#a90e00;
        }

        &__note {
            width:100%;
            height:calc(100vh - 340px);
            margin-bottom:30px;
            padding:20px;

            background-color: #eccf95;

            border-width:0;
            border-radius:10px;
            font-size: inherit;
            font-family: inherit;
            line-height: 1.5;

            @include bp($laptop) {
                height:calc(100vh - 300px);
            }

            &:focus {
                outline:none;
            }
        }

        &__buttons {
            display:flex;
            flex-direction: row;
            align-items: center;
            width:100%;
        }

        &__button {
            width:50%;

            &:first-child {
                margin-right:20px;
            }
            &:nth-child(2) {
                margin-left:20px;
            }
        }
    }
</style>